"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertDto = void 0;
const VehicleDropOffDto_1 = require("../vehicle-drop-offs/VehicleDropOffDto");
const VehicleDropOffMessageDto_1 = require("../vehicle-drop-off-messages/VehicleDropOffMessageDto");
class AlertDto {
    constructor(params) {
        this.typeOfAlert = "";
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.vehicleDropOffId = params.vehicleDropOffId;
        this.vehicleDropOffMessageId = params.vehicleDropOffMessageId;
        this.typeOfAlert = params.typeOfAlert;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        if (params.vehicleDropOff !== undefined) {
            this.vehicleDropOff = params.vehicleDropOff ?
                new VehicleDropOffDto_1.VehicleDropOffDto(params.vehicleDropOff) :
                null;
        }
        if (params.vehicleDropOffMessage !== undefined) {
            this.vehicleDropOffMessage = params.vehicleDropOffMessage ?
                new VehicleDropOffMessageDto_1.VehicleDropOffMessageDto(params.vehicleDropOffMessage) :
                null;
        }
    }
}
exports.AlertDto = AlertDto;
//# sourceMappingURL=AlertDto.js.map